import React, { useRef, useState } from 'react'
import LtsInputText from './lts-input-text'
import { lembrarMascara, valorAoDigitar, valorExibido } from '../../utils/cartaoNumeroMascarado'

/**
 * Numero do cartao que so mostra o gravado mascarado (PHOENIX-959). Ao focar um valor mascarado o campo fica vazio
 * para digitar o numero novo; sem digitar nada (ou apagando o que digitou) o valor volta a ser a mascara, que o back
 * entende como "nao trocou". Regras em utils/cartaoNumeroMascarado.
 *
 * Mesmas props do LtsInputText; onChange recebe o texto.
 */
export default function LtsInputCartaoNumero(props) {
  const { value, onChange, onFocus, onBlur, ...rest } = props
  const [editando, setEditando] = useState(false)
  const mascara = useRef(null)
  mascara.current = lembrarMascara(mascara.current, value)

  const onFocusNumero = (e) => {
    setEditando(true)
    onFocus?.(e)
  }

  const onBlurNumero = (e) => {
    setEditando(false)
    onBlur?.(e)
  }

  return (
    <LtsInputText
      {...rest}
      value={valorExibido(value, editando)}
      onChange={(texto) => onChange(valorAoDigitar(texto, mascara.current))}
      onFocus={onFocusNumero}
      onBlur={onBlurNumero}
      autoComplete="off"
    />
  )
}
